export default "__VITE_ASSET__Dj_Ci8SQ__"